<promo-banner></promo-banner>
<p class="title-heading" style="text-align: center;">Search Our Listings</p>

<!-- select controls -->
<div class="row">
    <div class="d-flex justify-content-center flex-column">
        <form class="row d-flex justify-content-center" id="search-form">
            <div class="col-2">&nbsp;</div>
            <div class="col-2" id="stateSelect">
                <select [(ngModel)]="selectedState" class="form-select w-100" name="states" id="states" (change)="onStateSelectionChange($event)">
                    <option value="0">All states</option>
                    <option *ngFor="let state of states" value={{state.fips}}>{{state.stateName}}</option>
                </select>
            </div>
            <div class="col-2" id="countySelect">
                <select [(ngModel)]="selectedCounty" class="form-select w-100" name="counties" id="county" (change)="onCountySelectionChange($event)">
                    <!-- static entry for all counties means it is populated when counties list is being re-filled -->
                    <option value="000">All counties</option>
                    <option *ngFor="let county of counties" value={{county.countyfp}}>{{county.name}}</option>
                </select>
            </div>
            <div class="col-2" id="offeringTypeSelect">
                <select [(ngModel)]="selectedOfferingType" class="form-select w-100" name="offeringType" id="offeringType" (change)="onOfferingTypeSelectionChange($event)">
                    <option value="All">Lease Types</option>
                    <option value="short">Short-term</option>
                    <option value="long">Long-term</option>
                </select>
            </div>
            <div class="reset-button col-2">
                <button class="btn btn-primary" type="button" (click)="reset()">
                  Start Over
                </button>
            </div>
            <div class="col-2">&nbsp;</div>
        </form>
    </div>
</div>

<!-- maps -->
<div class="row">
    <div *ngIf="(!selectedState || selectedState==='0') && !loading" class="d-flex justify-content-center">
        <us-map (stateSelected)="onStateMapClicked($event)" [offeringType]="selectedOfferingType"></us-map>
    </div>
    <div *ngIf="selectedState && selectedState!=='0'" class="d-flex justify-content-center">
        <state-counties [stateId]="selectedState" [offeringType]="selectedOfferingType" [countyId]="selectedCounty"></state-counties>
    </div>
</div>

<!-- sort by activity -->
<div *ngIf="!loading && selectedState!='0'" >
    <div class="accordion accordion" id="accordionFlushExample">
        <div class="accordion-item">
          <h2 class="accordion-header" style="width: fit-content; margin: 0 0 -4px 0;">
            <button class="btn btn-primary mb-1" type="button" data-bs-toggle="collapse" data-bs-target="#activitySelect" aria-expanded="true" aria-controls="activitySelect">
              Sort By
            </button>
          </h2>
          <div id="activitySelect" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
            <div class="form-check hstack" *ngFor="let activity of activities">
              <input class="form-check-input" (click)="onActivityClick(activity.id, $event.target.checked)" type="checkbox" value="" id="sortBy">
              <label class="form-check-label pb-1 pt-1" for="sortBy">
                {{activity.name}}
              </label>
            </div>
          </div>
        </div>
    </div>
</div>

<!--Listing results-->

<spinner *ngIf="loading" messageRelativePosition="bottom" message="Loading matching listings"> </spinner>
<div *ngIf="!loading && selectedState!='0'" class="col d-flex justify-content-center">
    <hr />
    <div class="row justify-content-md-center" id="search-results">
        <ng-container *ngIf="listings?.length > 0">
            <new-search-result *ngFor="let listing of listings" [listing]="listing"></new-search-result>
        </ng-container>
        <div *ngIf="listings?.length === 0" class="col-12">
            <div class="text-center">
                <!-- Rockingham County, Virginia (State 51, County 165) -->
                <ng-container *ngIf="selectedState === '51' && selectedCounty === '165'">
                    <hr />
                    <p>Rockingham County spans a dramatic swath of the Shenandoah Valley — from the fertile valley floor up through the ridges of the Blue Ridge and Allegheny-Mountain ranges, and across the forested spine of Massanutten Mountain. Such terrain variation — from lowland farmland and creek bottoms to steep mountain slopes and hardwood ridges — creates a mosaic of wildlife habitat that supports deer, small game, and turkey, making it a versatile landscape for many hunting styles. On private and managed lands (or adjoining public-forest mosaics), hunters can take advantage of natural funnels, ridgelines, and field-edge timber breaks that draw game. For leaseholders, Rockingham offers not only hunting opportunity but also landscape diversity — whether you prefer still-hunting timber ridges, setting stands along field-timber edges, or tracking deer in creek bottoms. With the right parcel, Rockingham can support both mature-buck hunts and long-term wildlife management.</p>
                    
                </ng-container>
                
                <!-- Page County, Virginia (State 51, County 139) -->
                <ng-container *ngIf="selectedState === '51' && selectedCounty === '139'">
                    <hr />
                    <p>Page County nestles in the eastern Shenandoah Valley, where forested ridges, mountain hollows, and sprawling timberland converge — offering hunters a peaceful, off-the-grid refuge. The rolling hills and wooded backcountry provide excellent cover for whitetail deer, and many privately held parcels have historically supported deer, turkey, and even black bear hunts. Some hunting outfits in the county maintain well-managed food plots and game-camera monitoring to help ensure a steady deer population. For hunters seeking privacy, varied terrain, and the chance for quality game without heavy pressure, Page County remains a quiet but promising option for a long-term lease.</p>
                </ng-container>
                
                
                <!-- Default message for all other counties -->
                <hr />
                <h5><strong>Sorry - we don't have any listings yet in {{ selectedCountyName ? selectedCountyName + ' County, ' : '' }}{{ selectedStateName }}.</strong></h5>
                
                <p><a href="javascript:void(0)" (click)="navigateToLandownerProfit()" class="oa-orange-link">Want to be the first</a>?</p>
                <p><a href="javascript:void(0)" (click)="reset()" class="oa-orange-link">Click here to start a new search</a></p>
            </div>     
        </div>
    </div>
</div>